import React from "react";

function CreateServiceModalServicePickerOptionContent({ children }) {
  return (
    <h5 className="flush text-align-center">
      {children}
    </h5>
  );
}

module.exports = CreateServiceModalServicePickerOptionContent;



// WEBPACK FOOTER //
// ./src/js/components/CreateServiceModalServicePickerOptionContent.js